import React from "react";

const TeamFeatures = () => (
    <div className="account-price">
        <p className="team-description">
            Icon Pro Team accounts get all the benefits of Pro with the extra
            perks of consolidated billing and easy icon sharing with kits.
        </p>
        <p className="team-description grey">
            If your team has 25+ members,{" "}
            <a href="mailto:info@thenounproject.com?subject=Team discount inquiry">
                contact us
            </a>{" "}
            for a discounted rate.
        </p>
    </div>
);

export default TeamFeatures;
